import "jquery-match-height"
const $ = jQuery

export default function TextLinkBoxesMatchHeight() {
  const WRAPPERS = document.querySelectorAll('.mtt-text-link-boxes')

  if  (WRAPPERS.length <= 0) {
    return
  }

  for (let i = 0; i < WRAPPERS.length; i++) {
    const WRAPPER = WRAPPERS[i]
    new MatchHeight(WRAPPER)
  }
}

class MatchHeight {
  constructor (WRAPPER) {
    this.WRAPPER = WRAPPER
    this.TITLES = this.WRAPPER.querySelectorAll('.mtt-text-link-box__header')

    if (this.TITLES.length <= 0) {
      return
    }

    $('.mtt-text-link-box__header').matchHeight()
  }
}